<div class="opciones">

    <div class="col-md-12 margin" style="padding-top: 10px;">
        <h4 class="card-title"> Expedientes </h4>
        <li *ngFor="let i of espedienteLinea" class="special-list">{{ i }} </li>
        <br>
        <div style="text-align: center;">
            <a>
                <button mat-raised-button class="button-special-pa" (click)="sign('seguimiento_expediente')">Seguimiento
                    de Expedientes</button>
            </a>
        </div>
    </div>

</div>